import React from "react";
import "./VpsSlider.scss";
import VpsSliderCard from "./VpsSliderCard/VpsSliderCard";

/*
  Тарифы VPS и Bitrix. Слайдера нет: тарифов шесть и три, на десктопе
  они помещаются в сетку целиком, листать нечего.
*/
const VpsSlider = ({ vpsData, title, subTitle, color, colorButton }) => {
  return (
    <div className="vpsSlider_container">
      <div className="vpsSlider_block">
        <div className="vpsSlider_title">
          <h1>{title}</h1>
          <p>{subTitle}</p>
        </div>
        <div className="vpsSlider_item">
          {vpsData?.map((e) => (
            <VpsSliderCard
              key={e.id}
              vpsSliderCards={e}
              color={color}
              colorButton={colorButton}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default VpsSlider;
